module.exports = function(notifications) {
	"use strict";
  notifications
  .controller('allNotificationsController', allNotificationsController)
	allNotificationsController.$inject = ["$timeout","keyPressOnlyNumberAndEnter","API_URL","addToOtherByUrl","deleteDataService","$http","$rootScope","NgTableParams", "getDataService", "jQuery","refreshtokenService","postDataService","alertService","serverError","offlineError", "$attrs"];
	
  function allNotificationsController($timeout,keyPressOnlyNumberAndEnter,API_URL,addToOtherByUrl,deleteDataService,$http,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,postDataService,alertService,serverError,offlineError,$attrs) {
    var vman = this;
    var state = 'pushnotifications';
    var $data;
    var s;
    vman.type= $attrs.type
    vman.notificationStatus = {};
    if($rootScope.role_id == 'superadmin' || $rootScope.role_id == 'administrator') {
      vman.adminPermisions = true;
    }
    vman.keyPressOnlyNumberAndEnter = keyPressOnlyNumberAndEnter
    vman.changeSearch = function(search_data) {
      if(!search_data) {
        $timeout(function() {
          vman.search();
        },0)            
      }
    }
    vman.reloadNotification = function(post,type) {
      var postFunction = function() {
        $rootScope.hasLoaded = false; 
        postDataService.save({
          param1: state,
          param2: (vman.type == 'eklinika')? vman.type:undefined,
          param3: 'reload',
          param4: type,
          param5: post._id
        },{}).$promise.then(function(postData){
          function mergeObjects(targetObj, sourceObj) {
            for (var key in targetObj) {
                if (targetObj.hasOwnProperty(key)) {
                    delete targetObj[key];
                }
            }
            for (var prop in sourceObj) {
                if (sourceObj.hasOwnProperty(prop)) {
                    targetObj[prop] = sourceObj[prop];
                }
            }
          }
          if(postData.notification) {
            mergeObjects(post, postData.notification);
          }
          $rootScope.hasLoaded = true;
          alertService('success','Success ', postData.message, 2000);
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  postFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          }else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        });
      }
      postFunction();
    }
    vman.saveEditTitle = function(post,type) {
      var putData = {}
      putData[type] = post['edit_'+type]
      var url = (vman.type == 'eklinika')? API_URL + state + '/eklinika/'+ post._id:API_URL + state + '/'+ post._id
      var putFunction = function() {
        $http.put(url , putData)
        .success(function (data, status, headers) {
          post[type] = post['edit_'+type];
          post['edit_'+type] = '';
          post['edit_'+ type+ 'Show'] = false;
          alertService('success','Success ', data.message, 2000);
        })
        .error(function (data, status, header, config) {
          if(!window.navigator.onLine) {
            offlineError()
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  putFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          }else if(status ==502) {
            serverError();
          } else {  
            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
          }
        });
      }
      putFunction();
    }
    vman.addToPushNotificationByUrlSuccessFunc = function(){
      if(vman.tableParams.page() ==1) {
        vman.tableParams.reload();
      } else {
        vman.tableParams.page(1);
      }
    }
    vman.addToOtherByURL = addToOtherByUrl;
    vman.sendNotification = function(user,type,notificationId, documentId,inPost) {
      if(vman.type == 'eklinika') {
        var data = {
          'notification_id' : notificationId
        }
      } else {
        var data = {
          'type': type,
          'document_id' : documentId,
          'notification_id' : notificationId,
          'post_id': (type=='liveblog_post' && inPost) ? inPost:undefined
        }
      }
      var postFunction = function() {
        $rootScope.hasLoaded = false; 
        postDataService.save({
          param1:state,
          param2: (vman.type == 'eklinika')? vman.type:undefined,
          param3: 'send',
          param4: user
        },data).$promise.then(function(postData){
          vman.tableParams.reload();
          alertService('success','Success ', postData.message, 2000);
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  postFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          }else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        });
      }
      postFunction();
    }
    vman.deleteNotification = function(id) {
      var deleteFunction = function() {
        deleteDataService.remove({
          param1:state,
          param2: (vman.type == 'eklinika')? vman.type:undefined, 
          param3: id
        }).$promise.then(function(deleteNotification){ 
          alertService('success','Success ', deleteNotification.message, 2000);
          vman.tableParams.reload();
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  deleteFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          }else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }  
        });
      }
      deleteFunction();
    }
    vman.search =function(value) {
      if(value) {
        s = value.toLowerCase();
      } else {
        s = null;
      }
      // user = null;
      // vmaa.selecteduserFilter = {value: 'all'};
      // unattached = null;
      // date_start = null;
      // date_end= null;
      // $scope.$broadcast('clear-daterange',true);
      // uploaded_to = null;
      vman.tableParams.reload();
    }
    vman.tableReloadFunction = function(page) {
      vman.tableParams = new NgTableParams({
        page: page || 1,
        count: 20,
          
      }, {
        getData: function(params) {
          $rootScope.hasLoaded = false;
          return getDataService.get({
            param1: state,
            param2: (vman.type == 'eklinika')? vman.type:undefined,
            page: params.page(),
            limit: params.count(),
            sortby: $rootScope.sortby,
            sort : $rootScope.sort,
            document_id:s
            }).$promise.then(function(data){
            $rootScope.emptyTable = false;
            $rootScope.hasLoaded = true;
            $data = data.push_notifications;
            vman.dataGet = data.push_notifications;
            if(data.push_notifications.length == 0) {
              $rootScope.emptyTable = true;
            } 
            params.total(data.count);
            params.numPages(data.max_pages);
            jQuery('.goTo input').val("");
            return $data;
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError('refresh')
              $rootScope.hasLoaded = true;
              return
            }
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {
                    vman.tableReloadFunction(params.page());
                  }
                  // do something
                },
                function(error) {
                },
                function(progress) {
                 // report progress
                });
            } else if(error.status ==404) {
              $rootScope.emptyTable = true;
            } else if(error.status ==502) {
                serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
            }
            $rootScope.hasLoaded = true;
            
          });
        }    
      });
    }
    vman.tableReloadFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/notificationsModule/allnotifications/js/allnotificationsController.js
// module id = 530
// module chunks = 0